<template>
  <section class="ToolBar">
    <div class="SearchbBar">
      <slot name="Search"></slot>
      <slot v-if="Type == 0" name="SearchTool"> </slot>
      <slot v-if="Type == 0" name="HandleTool"> </slot>
    </div>
    <div v-if="Type == 1" class="HandleBar">
      <slot name="SearchTool"> </slot>
      <slot name="HandleTool"> </slot>
    </div>
  </section>
</template>
<script>
export default {
  name: "ToolBar",
  data() {
    return {
      IsAutoHeight: false,
      IsSearhOverflow: false,
    };
  },
  props: {
    Type: {
      type: Number,
      default: 0,
    },
  },
  created() {},

  mounted() {
    //判断是否溢出
    // if (
    //   this.$refs.searchrow.scrollHeight - this.$refs.searchrow.offsetHeight >
    //   10
    // ) {
    //   this.IsSearhOverflow = true;
    // }
  },
  methods: {
    OnDownMoreClick() {
      this.IsAutoHeight = this.IsAutoHeight ? false : true;
    },
  },
};
</script>
<style lang="less" scoped>
.ToolBar {
  background-color: white;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  .SearchbBar {
    display: flex;
    .el-range-editor {
      margin-right: 5px;
    }
    .el-input {
      margin-right: 5px;
    }
    .el-select {
      margin-right: 5px;
    }
    .el-radio-group {
      margin-right: 5px;
    }
  }
  .HandleBar {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BzToolBar.vue